export default __webpack_public_path__ + "static/media/Gilroy-Bold.c087b737.woff2";